/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';

export const PARTS_OF_SPEECH = [
  'noun',
  'verb',
  'adjective',
  'adverb',
  'pronoun',
  'preposition',
  'conjunction',
  'interjection',
  'phrase',
  'exclamation',
  'determiner',
  'auxiliary_verb',
] as const;

export const partOfSpeechSchema = z.enum(PARTS_OF_SPEECH);

export type IPartOfSpeech = z.infer<typeof partOfSpeechSchema>;
